import Vue from "vue";
import App from "./App.vue";

/* Vue Filters */
import NoSpaceFilter from "./core/filters/noSpace";
import FirstLetterUppercase from "./core/filters/firstLetterUppercase";
Vue.filter("noSpace", NoSpaceFilter);
Vue.filter("firstLetterUppercase", FirstLetterUppercase);

/* Core Libraries */
import router from "./router";
import axios from "axios";
import i18n from "./i18n";
import store from "./core/store/store";
import vuetify from "./plugins/vuetify";

/* UI based Components global registration */
import { baseComponentsGlobalRegistration } from "./plugins/baseComponentsGlobalRegistration";
baseComponentsGlobalRegistration(Vue);

Vue.config.productionTip = false;

/* Embeb youtube video Library */
import VueYouTubeEmbed from "vue-youtube-embed";
Vue.use(VueYouTubeEmbed, { global: true, componentId: "youtube-media" });

/* Sentry Production Monitoring Packages */
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

import "material-design-icons-iconfont/dist/material-design-icons.css";
import "mapbox-gl/dist/mapbox-gl.css";

/* Sentry Production Monitoring Configuration  */
if (
  process.env.VUE_APP_SENTRY_ENVIRONMENT === "staging" ||
  process.env.VUE_APP_SENTRY_ENVIRONMENT === "production"
) {
  Sentry.init({
    dsn: "https://b30313d5a2914c33996cdeef49855b3a@sentry.io/5181442",
    integrations: [
      new Integrations.Vue({ Vue, attachProps: true, logErrors: true })
    ],
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT
  });
}

/* Axios configuration */
const accessToken = localStorage.getItem("access_token");
axios.defaults.baseURL = process.env.VUE_APP_URL_API;
axios.defaults.headers.post["Content-Type"] = "application/json";
if (accessToken) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
}
/* Matomo configuration */
import VueMatomo from "vue-matomo";
if (process.env.VUE_APP_SENTRY_ENVIRONMENT === "production") {
  Vue.use(VueMatomo, {
    host: "https://gemmici.matomo.cloud/",
    siteId: 2,
    trackerFileName: "matomo",
    router: router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    disableCookies: false,
    cookieDomain: "*.gemmici.com",
    domains: "*.gemmici.com",
    preInitActions: []
  });
}
new Vue({
  router,
  store,
  i18n,
  vuetify,
  created() {
    // Check if accessToken is valid, if yes auto login user
    const accessToken = localStorage.getItem("access_token");
    if (
      accessToken &&
      typeof accessToken === "string" &&
      accessToken.length > 0
    ) {
      this.$store.dispatch("account/autoLogIn", accessToken);
    }
    // end auto login
  },
  render: h => h(App)
}).$mount("#app");
